import { Grid } from '@nt/dds-react';
import React, { ReactElement } from 'react';
import Navbar from '../Navbar';

import './Layout.css';

interface Props {
  children?: ReactElement;
}

const Layout: React.FC<Props> = ({ children }): ReactElement => (
  <main className="display-flex flex-grow-1">
    <Grid fluid className="fluid-container">
      <div className="fluid-nav-bar">
        <Navbar />
      </div>
      <div className="fluid-content-wrap">{children}</div>
    </Grid>
  </main>
);

Layout.displayName = 'Layout';
export default Layout;
